import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getContextModules, getComponent } from "@/lib/requireContextHelpers";
import ContentFeedItem from "./ContentFeedItem.vue";

const modules = getContextModules(require.context("./views/", true, /\.\/[a-zA-Z]*View\/index.ts/));

export default function(item: ContentFeed) {
  return getComponent(modules, item, ContentFeedItem);
}

export interface ProcessedContentFiles {
  locked: ContentFile[];
  accessed: ContentFile[];
  all: ContentFile[];
}
